module.exports = __webpack_public_path__ + "img/filter-main.614941f8.svg";